import { css } from "@emotion/react";

import { COLORS } from "styles-js";

export const radioCard = css({
  width: "100%"
});

export const radioOption = (isSelected: boolean, isDisabled?: boolean) =>
  css({
    position: "relative",
    display: "block",
    border: `1px solid ${
      isSelected ? COLORS.darkBlueGrey : COLORS.paleGreyFour
    }`,
    backgroundColor: isSelected ? COLORS.paleGreyTwo : COLORS.white,
    boxShadow: isSelected ? "0 3px 6px 0 #0033671f" : "none",
    cursor: isDisabled ? "not-allowed" : "pointer",
    opacity: isDisabled ? 0.6 : 1,
    transition: "all 0.2s ease",
    outline: "none",
    "&:hover": !isDisabled && {
      borderColor: COLORS.primary,
      backgroundColor: COLORS.paleGreyTwo
    },
    "&:focus-visible": {
      boxShadow: "0 0 0 3px rgba(0, 123, 255, 0.25)"
    }
  });

export const hiddenInput = css({
  position: "absolute",
  opacity: 0,
  width: 0,
  height: 0,
  pointerEvents: "none"
});

export const optionContent = css({
  height: "100%"
});

export const checkIcon = css({
  position: "absolute",
  top: "3px",
  right: "3px",
  width: "16px",
  height: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: COLORS.dark
});
